export default __webpack_public_path__ + "static/media/edit-offline-payment-icon.9a7e9a27.svg";